import React from 'react';
import { ArrowUpRightIcon, PhoneIcon, ShieldCheckIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_TEL, GuidanceLine } from './shared';
export function FinalCTA() {
  return <section id="quick-claim-form" className="w-full bg-forest-700 text-paper" data-id="element-233" data-mp="c6iultloo175">
      <div className="mx-auto w-full max-w-6xl px-5 py-12 sm:px-6 md:py-14 lg:px-8 lg:py-16" data-id="element-234" data-mp="c4fv8iyn4vpr">
        <div className="mx-auto max-w-3xl text-center" data-id="element-235" data-mp="87jrmejiieic">
          <div className="flex justify-center" data-id="element-236" data-mp="m3x04y62j5ko">
            <GuidanceLine data-id="element-237" data-mp="m2lxj1od03v5" />
          </div>
          <h2 className="mt-4 font-serif text-[32px] font-medium leading-[1.12] tracking-[-0.015em] text-paper md:text-[40px]" data-id="element-238" data-mp="h4u4g4bzabpd">
            You Do Not Need Every Answer Before You Contact Us
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-body text-paper/75" data-id="element-239" data-mp="qwztp6auif0v">
            Start with the free claim check above or call the Highgate team. A
            confidential first conversation can help you understand the next step.
          </p>

          <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-240" data-mp="2c4o9os7okz43">
            <a href="#compensation-calculator" className="inline-flex min-h-[54px] items-center justify-center gap-2 rounded-btn bg-signal px-6 text-body font-semibold text-paper shadow-[0_8px_24px_-10px_rgba(188,63,32,0.75)] transition-[transform,background-color] duration-200 ease-out hover:-translate-y-0.5 hover:bg-signal-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-light" data-id="element-241" data-mp="2c6hgc7ianjc3">
              Start free claim check
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-242" data-mp="30111o3s730y2" />
            </a>
            <a href={PHONE_TEL} className="inline-flex min-h-[54px] items-center justify-center gap-2 rounded-btn border border-paper/25 px-6 text-body font-semibold text-paper transition-colors duration-200 ease-out hover:bg-paper/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-light" data-id="element-243" data-mp="34un1uwh69ccz">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-244" data-mp="1jo3i5j6gg94k" />
              Call {PHONE_DISPLAY}
            </a>
          </div>

          <p className="mt-5 inline-flex items-center justify-center gap-2 text-small text-paper/65" data-id="element-245" data-mp="1eqbejrwg6ykj">
            <ShieldCheckIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-246" data-mp="1shou6ur8jcaa" />
            Free initial discussion · Confidential · No obligation
          </p>
        </div>
      </div>
    </section>;
}